<template>
    <a class="onepic-content" :href="articleData.url" :data-spm-data="templateSpm">
        <div class="left content-info">
            <h3 class="title">{{articleData.title}}</h3>
            <h3 class="onepic-author">作者：{{articleData.author}}</h3>
        </div>
        <div class="right picture">
            <img :src="setPicSize(articleData.cover, 174, 116, 'c_fill')" :data-src="preloadImg"/>
        </div>
    </a>
</template>

<script>
import PicUtils from '../../_utils/pic-util.js';
export default {
    name: 'ArtOnepicItem',
    data(){
        return {
            setPicSize: PicUtils.setPicSize,
            preloadImg: `//47f72d130392f.cdn.sohucs.com/web/static/images/pic/preload.png`
        }
    }
}
</script>

<style lang="less" scoped>
@import '../../less/base/mixins.less';
    .onepic-content {
        display: block;
        box-sizing: border-box;
        height: 172px;
        width: 100%;
        padding: 22px 20px 28px 28px;
        border-radius: 6px;
        background: #F0F0F0;
        .content-info {
            width: 440px;
            margin-right: 28px;
            .title {
                height: 88px;
                margin-bottom: 10px;
                font-size: 32px!important;/*px*/
                line-height: 44px;
                overflow: hidden;
                .line-clamp(2);
                color: #656565;

            }
            .onepic-author {
                font-size: 24px;/*px*/
                // line-height: 24px;
                color: #A4A4A4;
            }
        }
        .picture {
            width: 174px;
            height: 116px;
        }
    }
</style>
